import { motion } from "framer-motion";
import { ListChecks, PhoneCall, FileCheck } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const STEPS = [
  { icon: ListChecks, n: "Step 01", title: "Pick your coverage", text: "Individual, family, or small business. Tell me your situation and I'll walk you through the plans that fit — no pressure, no jargon." },
  { icon: PhoneCall, n: "Step 02", title: "Meet your provider firm", text: "Once enrolled, you're connected to a dedicated law firm in your state. Reach them by phone or app whenever a question comes up." },
  { icon: FileCheck, n: "Step 03", title: "Use it like a safety net", text: "Documents reviewed, calls made, letters sent, advice on tap — and trial defense hours if you ever need to go further." },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.15, duration: 0.8, ease: EASE } }),
};

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-white py-24 md:py-36 scroll-mt-20" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <motion.p variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} custom={0}
          className="font-mono-accent text-xs uppercase tracking-[0.28em] text-blue-600 mb-6">
          How it works
        </motion.p>
        <motion.h2 variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} custom={1}
          className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#0B192C] max-w-2xl leading-[1.1] mb-20">
          Three steps between you and a law firm.
        </motion.h2>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          <div className="hidden md:block absolute top-9 left-[12%] right-[12%] h-px bg-gradient-to-r from-blue-200 via-blue-400 to-blue-200" />
          {STEPS.map((s, i) => (
            <motion.div key={s.n} variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }} custom={i + 1}
              className="relative" data-testid={`how-step-${i}`}>
              <span className="relative z-10 w-[72px] h-[72px] rounded-2xl bg-[#EFF6FF] border border-blue-200 text-blue-700 flex items-center justify-center mb-7">
                <s.icon size={28} strokeWidth={1.7} />
              </span>
              <p className="font-mono-accent text-[11px] uppercase tracking-[0.25em] text-blue-600 mb-3">{s.n}</p>
              <h3 className="font-display font-bold text-xl text-[#0B192C] mb-3 tracking-tight">{s.title}</h3>
              <p className="text-slate-600 leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
